module.exports = __webpack_public_path__ + "img/prop-trade-header-bg2.7d1097cd.png";